import axiosInstance from 'src/utils/axios';
import {
  ConnectToMerchantLandingPagePayload,
  GetDefaultTLPSettingsQuery,
  GetLandingPagesQuery,
  GetLandingPagesResponse,
  LandingPageSettings,
  UpdateLandingPageDomainPayload,
} from './types.api';

//
//

const BASE_URL = '/cms/v1/component-settings/landing-pages';

//

export const getListOfLandingPagesAPI = async (
  query: GetLandingPagesQuery
): Promise<GetLandingPagesResponse> => {
  const { merchantCode, programmeCode } = query;

  const response = await axiosInstance.get<GetLandingPagesResponse>(`${BASE_URL}`, {
    params: { merchantCode, programmeCode },
  });

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const getDefaultComponentSettingsAPI = async (
  query: GetDefaultTLPSettingsQuery
): Promise<LandingPageSettings> => {
  const response = await axiosInstance.get<LandingPageSettings>(`${BASE_URL}/default`, {
    params: query,
  });

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const getSettingsByIdAPI = async (
  componentConfigId: string
): Promise<LandingPageSettings> => {
  const response = await axiosInstance.get<LandingPageSettings>(`${BASE_URL}/${componentConfigId}`);

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

const sendComponentSettingsAPI = async (
  componentSettings: LandingPageSettings
): Promise<LandingPageSettings> => {
  const response = await axiosInstance.post<LandingPageSettings>(
    `${BASE_URL}`,
    JSON.stringify(componentSettings)
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const saveComponentSettingsAPI = async (payload: ConnectToMerchantLandingPagePayload) => {
  const { merchantCode, componentSettings, programmeCode } = payload;

  const generalSettings = componentSettings?.generalSettings;
  const newSubdomain = generalSettings?.subdomain;
  delete generalSettings.subdomain;

  const componentSettingsApiResponse = await sendComponentSettingsAPI(componentSettings);
  const componentSettingsId = componentSettingsApiResponse.id;
  const body = { subdomain: newSubdomain };

  await axiosInstance.post<LandingPageSettings>(
    `${BASE_URL}/${componentSettingsId}/merchant/${merchantCode}`,
    body,
    { params: { programmeCode } }
  );

  return componentSettingsApiResponse;
};

export const updateComponentSettingsAPI = async (
  merchantCode: string,
  landingPageId: string | undefined,
  componentConfigId: string,
  componentSettings: LandingPageSettings,
  status: boolean,
  domain?: string
) => {
  const generalSettings = componentSettings?.generalSettings;

  if (domain || status !== undefined) {
    let newStatus: string | undefined;
    if (status !== undefined) {
      newStatus = status ? 'ACTIVE' : 'INACTIVE';
    }

    await patchLandingPageDomainAPI({
      merchantCode,
      landingPageId,
      domain,
      status: newStatus,
    });
  }

  delete generalSettings.subdomain;

  return axiosInstance.put<LandingPageSettings>(
    `${BASE_URL}/${componentConfigId}`,
    componentSettings
  );
};

//This endpoint also allows status and path patching
const patchLandingPageDomainAPI = async (payload: UpdateLandingPageDomainPayload) => {
  const { merchantCode, landingPageId, domain, status } = payload;

  const body = {
    ...(domain && { subdomain: domain }),
    ...(status && { status }),
  };

  await axiosInstance.patch<LandingPageSettings>(
    `${BASE_URL}/${landingPageId}/merchant/${merchantCode}`,
    body
  );
};
